import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-24 md:py-32 px-4 bg-primary text-center relative overflow-hidden" data-id="element-74">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-75"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cta/20 rounded-full blur-[120px] pointer-events-none" data-id="element-76"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <p className="text-xl md:text-2xl text-beige/80 mb-4 font-serif italic" data-id="element-79">
            Podés seguir como estás…
          </p>
          <p className="text-xl md:text-2xl text-beige/80 mb-10 font-serif italic" data-id="element-80">
            o podés tomar una decisión hoy.
          </p>

          <h2 className="text-3xl md:text-5xl font-bold text-warm mb-12 leading-tight" data-id="element-81">
            En 30 días vas a ser la misma persona…{' '}
            <br className="hidden md:block" data-id="element-82" />
            <span className="text-highlight" data-id="element-83">
              o alguien completamente distinto.
            </span>
          </h2>

          <div className="bg-white/5 border border-white/10 p-8 rounded-2xl backdrop-blur-sm mb-10 inline-block" data-id="element-84">
            <p className="text-2xl md:text-3xl font-bold text-warm mb-2" data-id="element-85">
              El cambio no empieza mañana.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-cta" data-id="element-86">
              Empieza ahora.
            </p>
          </div>

          <div data-id="element-87">
            <CTAButton text="Empezá tu transformación 🚀" className="w-full sm:w-auto text-xl py-5 px-10" showIcon={false} data-id="element-88" />
          </div>
        </motion.div>
      </div>
    </section>;
}